import SnakeEasterChallenge from "../components/SnakeEasterChallenge";
import TerminalWindow from "../components/TerminalWindow";

export default function StanleyPage() {
  return (
    <TerminalWindow>
      <SnakeEasterChallenge />
    </TerminalWindow>
  );
}
